import React, { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { socket } from "../../../../socket";

import styles from "../../GameSelector.module.css";

interface Props {
  setCodeRequested: Dispatch<SetStateAction<boolean>>;
}

function AddNumberOfPlayers({ setCodeRequested }: Props) {
  const [isNumberOfPlayersAdded, setIsNumberOfPlayersAdded] =
    useState<boolean>(false);
  const [players, setPlayers] = useState<number>();
  const { t } = useTranslation();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPlayers(Number(e.target.value));
  };

  const handleOnSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsNumberOfPlayersAdded(true);
    setCodeRequested(true);
    socket.connect();
    socket.emit("create room", players);
  };

  return (
    <div className="AddNumberOfPlayers">
      <h2 className={styles.title}>{t("AddNumberOfPlayers.title")}</h2>
      <div className={styles.body}>
        <form className={styles.formPlayers} onSubmit={handleOnSubmit}>
          <div className={styles.group}>
            <input
              className={styles.field}
              id="players"
              name="players"
              type="number"
              placeholder={String(t("AddNumberOfPlayers.placeholder"))}
              min="2"
              max="4"
              onChange={handleOnChange}
              required
              autoFocus
            />
            <label className={styles.label} htmlFor="players">
              {t("AddNumberOfPlayers.label")}
            </label>
          </div>
          <div className={styles.description}>
            {t("AddNumberOfPlayers.description")}
          </div>
          <div className={styles.actions}>
            {isNumberOfPlayersAdded ? (
              <button
                className={[styles.button, "loading-state"].join(" ")}
                type="submit"
                disabled
              >
                {t("App.submitting")}
              </button>
            ) : (
              <button className={styles.button} type="submit">
                {t("AddNumberOfPlayers.submitButton")}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddNumberOfPlayers;
